import { jsx as _jsx } from "react/jsx-runtime";
const SvgCsBomb = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.5 0L5.5 5L3.5 3V6.5L0 5L2.5 8.5L0.5 10.5H3.5L4 14L5 11L7 13V11L9.5 13.5L9 11L13 13L10 10L13.5 8H10L12.5 5.5L9 6L10 2.5L7.5 5V0Z",
		fill: "currentColor"
	})
});
export default SvgCsBomb;
